import React, {useMemo, useState} from "react";
import styles from "../../styles.module.css"
import {TextBalloon} from "../../common/TextBalloon";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {
    selectDayNumber,
    selectNightData,
    selectPersistentNightData, selectPlayers
} from "../../../features/weerwolven/slices/GameSelectors";
import {solveWereWolfKill} from "../../../features/weerwolven/utils/night-solver/Utils";
import {Role} from "../../../features/weerwolven/data/Role";
import {moveToNextPhase, moveToPreviousPhase, setNightData} from "../../../features/weerwolven/slices/GameSlice";
import {DoesHeksHealScreenPart} from "./DoesHeksHealScreenPart";
import {SelectablePlayer} from "../../common/SelectablePlayer";

export function NormalNightHeksPhase() {
    const currentNight = useAppSelector(selectDayNumber) + 1
    const nightData = useAppSelector(selectNightData)
    const persistentNightData = useAppSelector(selectPersistentNightData)
    const dispatch = useAppDispatch()
    const weerwolvenResult = useMemo(() => solveWereWolfKill({
        werewolvesTarget: nightData.weerwolven.currentWeerwolvenTarget,
        stamoudste: persistentNightData.stamoudste,
        isStamoudsteProtected: persistentNightData.stamoudsteProtected,
        genezerTarget: nightData.genezer.currentGenezerTarget,
        doesKlauwWolfKlauw: nightData.klauwWolf.doesKlauwWolfInfect,
        cupidoBedPartner: nightData.cupido.currentBedPartner,
        cupido: persistentNightData.cupido,
        doesHeksHeal: false
    }), [])
    const [doesHeksKill, setDoesHeksKill] = useState(false)
    useMemo(() => {
        if (nightData.heks.heksKillTarget !== "") {
            setDoesHeksKill(true)
        }
    }, [nightData.heks.heksKillTarget])
    const players = useAppSelector(selectPlayers).getAlivePlayers()


    return (<div>
        <div className={`${styles.Breadcrumb}`}>{currentNight}e Nacht / Heks</div>

        <TextBalloon
            text={<>De Heks mag wakker worden.<br/>Heks, deze persoon is vannacht gedood. Wil je je levensdrankje
                gebruiken?</>}/>

        <DoesHeksHealScreenPart weerwolvenResult={weerwolvenResult}/>

        <TextBalloon text={<>Heks, wil je deze nacht je doods drankje gebruiken? En zo ja, op wie?</>}/>

        {persistentNightData.heksCanUseDeathPotion ? <>
                <p className={`${styles.Vraag}`}>Gebruikt de Heks het doods drankje?<br/>
                    <button className={`${styles.JaNee} ${doesHeksKill ? styles.Selected : ""}`}
                            onClick={() => {
                                setDoesHeksKill(true)
                            }}>Ja</button>
                    <button className={`${styles.JaNee} ${!doesHeksKill ? styles.Selected : ""}`}
                            onClick={() => {
                                setDoesHeksKill(false)
                                nightData.heks.heksKillTarget = ""
                                dispatch(setNightData(nightData))
                            }}>Nee</button>
                </p>

                {doesHeksKill ? <>
                    <p className={`${styles.Vraag}`}>Wie wijst de Heks aan?</p>
                    <div className={`${styles.NamenSelecteren}`}>
                        {players.filter(player => player.role !== Role.HEKS)
                            .map(player => {
                                return <SelectablePlayer name={player.name} key={player.name}
                                                         isSelected={player.name === nightData.heks.heksKillTarget}
                                                         onClick={() => {
                                                             nightData.heks.heksKillTarget = player.name
                                                             dispatch(setNightData(nightData))
                                                         }}/>;
                            })}
                    </div>
                </> : ""}
            </> :
            <p>Het doods drankje is al gebruikt.</p>}

        <div className={`${styles.TerugVerder}`}>
            <button className={`${styles.ButtonTerug}`} onClick={() => {
                dispatch(moveToPreviousPhase())
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}>Terug</button>
            <button className={`${styles.ButtonVerder}`} disabled={
                doesHeksKill && nightData.heks.heksKillTarget === ""
            } onClick={() => {
                dispatch(moveToNextPhase())
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}>Verder</button>
        </div>
    </div>)
}